export const sx = {
    checkbox: {
        padding: '0',

    },
    label: {
        margin: '0!important',
        padding: '0 3px',
    }
}
